module.exports = __webpack_public_path__ + "static/media/listing-page-lonavala.f0b74391.jpg";